import React from "react";
import { Button } from "./Button";
export const Dropdown = ({ icon: Icon, title, value, onChange = (option) => { }, alignMenu = "center", options = [], classNames = [], }) => {
    const [open, setOpen] = React.useState(false);
    const classes = [
        "tnic-dropdown",
        open && "tnic-dropdown__active",
        `tnic-dropdown__${alignMenu}`,
        ...classNames,
    ].filter(Boolean);
    function listener() {
        setOpen(false);
        return false;
    }
    React.useEffect(() => {
        setTimeout(() => {
            if (open) {
                document.addEventListener("click", listener);
            }
            else {
                document.removeEventListener("click", listener);
            }
        }, 0);
        return () => {
            document.removeEventListener("click", listener);
        };
    }, [open]);
    return (React.createElement("div", { className: classes.join(" ") },
        React.createElement(Button, { basic: true, onClick: (e) => {
                setOpen(!open);
            }, icon: !!Icon },
            Icon && React.createElement(Icon, null),
            title),
        React.createElement("div", { className: "tnic-dropdown--menu" }, options.map((option) => {
            const Icon = option.icon;
            return (React.createElement("div", { key: option.label, role: "option", className: [
                    "tnic-dropdown--item",
                    value === option.value && "tnic-dropdown__selected",
                ]
                    .filter(Boolean)
                    .join(" "), onClick: () => onChange(option) },
                Icon && React.createElement(Icon, null),
                option.label));
        }))));
};
//# sourceMappingURL=Dropdown.js.map